import { render, staticRenderFns } from "./groupReleaseTrace.vue?vue&type=template&id=16ccabf0&scoped=true"
import script from "./groupReleaseTrace.vue?vue&type=script&lang=js"
export * from "./groupReleaseTrace.vue?vue&type=script&lang=js"
import style0 from "./groupReleaseTrace.vue?vue&type=style&index=0&id=16ccabf0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16ccabf0",
  null
  
)

export default component.exports